<template>
  <div class="bottom">
    <div class="bomTopBox">
      <div class="slogan">
        <h5>线上培训学习，消除地域壁垒，随时随地学习</h5>
        <a href="javascript:;" @click="openZixun" class="seekBtn">在线咨询</a>
      </div>
    </div>
    <div class="bomBomBox">
      <div class="topBox">
        <div class="w1600 clearfix">
          <div class="leftBox">
            <div class="contaDes">
              <div class="logoBom">
                <img :src="$uploadfiles() + form.phoneImage" alt="" />
              </div>
              <div class="timeBom">咨询时间：{{ form.rank }}</div>
            </div>
            <div class="phoneNum">
              <span>考前培训</span>
              <div class="des">
                <h5>{{ form.info1 }}</h5>
                <p class="pho">{{ form.info3 }}</p>
                <p class="pho">{{ form.info4 }}</p>
              </div>
            </div>
          </div>
          <div class="rightBox">
            <h5>关注兰麦官方公众号</h5>
            <span class="tip">获取更多课程信息</span>
            <ul>
              <li>
                <div class="imgBox">
                  <img :src="$uploadfiles() + form.image1" alt="" />
                </div>
                <p>兰麦考前小助手</p>
              </li>
              <li>
                <div class="imgBox">
                  <img :src="$uploadfiles() + form.image2" alt="" />
                </div>
                <p>北京兰麦服务号</p>
              </li>
              <li>
                <div class="imgBox">
                  <img :src="$uploadfiles() + form.image2" alt="" />
                </div>
                <p>兰麦教育订阅号</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bomBox">
        <div class="w1600 clearfix">
          <ul class="link clearfix">
            <li>
              <a href="javascript:;" @click="$pushTo(`/BeforeExam/aboutUs`)"
                >关于我们</a
              >
            </li>
            <li>
              <a href="javascript:;" @click="$pushTo(`/BeforeExam/contactUs`)"
                >联系我们</a
              >
            </li>
            <li>
              <a href="javascript:;" @click="$pushTo(`/BeforeExam/legalNotice`)"
                >法律声明</a
              >
            </li>
            <li>
              <a href="javascript:;" @click="$pushTo(`/BeforeExam/link`)"
                >友情链接</a
              >
            </li>
          </ul>
          <p class="copy">
            {{ form.label
            }}<a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              class="icp"
              >{{ form.illustrate }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="common_sidebar">
    <div class="item" @click="$onlineconSultation()">
      <img src="@/assets/images/icon18.png" alt="" />
      <p>在线客服</p>
    </div>
    <div class="item">
      <img src="@/assets/images/icon19.png" alt="" />
      <p>联系我们</p>
      <div class="box" v-html="form.remark"></div>
    </div>
    <div class="item" @click="$pushTo(`/BeforeExam/memberCart`)">
      <img src="@/assets/images/trolley.png" alt="" />
      <p>购物车</p>
    </div>
    <!-- <div class="item" @click="$pushTo(`/BeforeExam/memberOrder`)">
      <img src="@/assets/images/icon21.png" alt="" />
      <p>我的订单</p>
    </div> -->
  </div>

  <div class="idxFixbox">
    <ul>
      <!-- <li class="seek">
        <a href="javascript:;" @click="$onlineconSultation()"></a>
        在线客服
      </li>
      <li class="phon">
        <a href="javascript:;"></a>
        <div class="box" v-html="form.remark">
          
        </div>
      </li>
      <li class="memr">
        <a href="javascript:;" @click="$pushTo(`/BeforeExam/personalCenter`)"></a>
        个人中心
      </li>
      <li class="pape">
        <a href="javascript:;" @click="$pushTo(`/BeforeExam/memberOrder`)"></a>
        我的订单
      </li> -->
      <li class="goTop">
        <a @click="toTop"></a>
      </li>
    </ul>
  </div>
</template>
 
<script>
import { GetItemById } from "@/api/content";
export default {
  data() {
    return {
      form: {},
    };
  },
  created() {
    this.loadinfo();
  },
  methods: {
    loadinfo() {
      var that = this;
      GetItemById({
        columnId: 23,
      })
        .then((res) => {
          that.form = res.body;
        })
        .catch((err) => {});
    },
    // 回到顶部
    toTop() {
      $("body,html").animate({ scrollTop: 0 }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>